const parseTeam = (team) => team || '';

export const getTeamsById = (teams = []) =>
  (Array.isArray(teams) ? teams : []).reduce(
    (acc, curr) => ({
      ...acc,
      [curr.id]: {
        abbr: parseTeam(curr.abbr),
        city: parseTeam(curr.city),
        id: parseTeam(curr.id),
        logo: parseTeam(curr.logo),
        name: parseTeam(curr.name),
      },
    }),
    {},
  );
